/* eslint-disable react/button-has-type */
// we are making sure that button has a type, but eslint does not recognize it
import React from 'react';
import PropTypes from 'prop-types';
import s from './Button.module.scss';

function Button(props) {
  const { variant, type, onClick, className, disabled, children } = props;

  let buttonClasses = s.button;
  buttonClasses = `${buttonClasses} ${className} ${s[variant]}`;

  return (
    <button
      type={
        type === 'button' || type === 'submit' || type === 'reset'
          ? type
          : 'button'
      }
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

Button.defaultProps = {
  type: 'button',
  className: '',
  disabled: false,
  onClick: null,
};

Button.propTypes = {
  /** Visual variant of the button */
  variant: PropTypes.oneOf(['primary', 'secondary', 'textOnly']).isRequired,
  /** Type is passed to the html button. Setting the correct type is important for accessibility. */
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  /** Function to call on button click */
  onClick: PropTypes.func,
  /** Classes to apply to html button */
  className: PropTypes.string,
  /** Button content e.g. text to display */
  children: PropTypes.node.isRequired,
  /** Button disable */
  disabled: PropTypes.bool,
};

export default Button;
